import React from "react";
import { DataGrid, GridToolbarContainer, GridToolbarExport, gridClasses } from '@mui/x-data-grid';
import { useNavigate } from "react-router-dom";
import { I18nPropvider } from './../i18nProvider';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { TailSpin } from "react-loader-spinner";

function CustomToolbar() {
  return (
    <GridToolbarContainer className={gridClasses.toolbarContainer}>
      <GridToolbarExport printOptions={{ allColumns: true , hideToolbar: true }} />
    </GridToolbarContainer>
  );
}

export function SortedDescendingIcon() {
  return <ArrowDownwardIcon className="icon blue-color" />;
}

export function SortedAscendingIcon() {
  return <ArrowUpwardIcon className="icon blue-color" />;
}

export function TableauChaines({ searchLoading, channels, locale, columns }) {
  const navigate = useNavigate();
  const [sortModel, setSortModel] = React.useState([
    {
      field: 'channelName',
      sort: 'asc',
    },
  ]);


  return (
    <I18nPropvider locale={locale}>
      <div id="resultatRecherche" className="bg-white" style={{ height: 400, width: '100%' }}>
        {
          searchLoading && (
            <div style={{ paddingTop: '100px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <TailSpin color="#3388ff"></TailSpin>
            </div>
          )
        }

        {
          !searchLoading && (
            <DataGrid rows={channels} columns={columns} onRowClick={(data) => {
              navigate('/channel/' + data.id, {state : {locale : locale}});
            }}
              components={{ Toolbar: CustomToolbar, ColumnSortedDescendingIcon: SortedDescendingIcon, ColumnSortedAscendingIcon: SortedAscendingIcon }}
              sortModel={sortModel}
              onSortModelChange={(model) => setSortModel(model)}
            />

          )
        }
      </div>
    </I18nPropvider >

  );
}

export default TableauChaines;